<template>
 <div class="container">
    <h1>
      <!-- <font-awesome-icon icon="home" /> -->
      <b-icon icon="person-square"></b-icon> BookCourse
        <div class="float-right" style="margin-top: -62px">
        <b-button
          v-b-modal.modal-help
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >

<help id="16"/>
        
      </div>
    </h1>


<div class="row mt-3" >
  <div class="col-md-12">
   <b-alert show v-if="Successful &&errormsg==''" variant="success" >Booked successfully</b-alert>
 <b-alert v-if="!!errormsg" variant="warning" show>{{this.errormsg}}</b-alert>
 <!-- <b-alert v-if="!IsMale" variant="warning" show>Only Males are allowed to book.</b-alert> -->
  </div>
                 <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="empty">
                    No Data
                  </b-card>
              
<div v-else v-for="course in Courses" v-bind:Key="course.Serial" class="col-md-4 mb-3">
  <b-card-group deck>
    
    <b-card
      header=''
      header-tag="header"
     
     
      title="Course Description "
    >
    <template #header>
      {{course.CourseNameAr}}
    </template>
    <p>{{course.Description}}</p>
      <b-card-text><strong>Start date: </strong> {{course.StartDate| moment("llll")}}.</b-card-text>
      <b-card-text><strong>End date: </strong> {{course.EndDate| moment("llll")}}</b-card-text>
      <b-card-text><strong>Registration Start Date: </strong> {{course.RegistrationStartDate| moment("llll")}}</b-card-text>
      <b-card-text><strong>Registraton End Date: </strong> {{course.RegistratonEndDate| moment("llll")}}</b-card-text>
      <!-- <b-card-text><strong>Result: </strong> </b-card-text> -->
      <b-card-text><strong>Price: </strong> {{course.Price}}</b-card-text>
       <b-card-text><strong>Status: </strong> {{course.CourseStatusId}}</b-card-text>
     <div class="text-center" >
       <!-- <b-button  variant="primary"  class="btn btn-primary text-center"  @click="BookCourse" :disabled="!IsFemale">Submit</b-button> -->
       <b-button  variant="primary"  class="btn btn-primary text-center"  @click="BookCourse" >Submit</b-button>
       </div>
    </b-card>

   
  </b-card-group>
</div>

<div class="col-md-12 text-right w-100 mt-3 mb-4">
 
<div class="  ">
 <button class="btn btn-primary " @click="Back" >Your Course</button>
</div>
 
   
</div>

 </div>

<div class="panal mt-20 " style="display:none">
<div class="panal-header">Book Course </div>



   <b-alert variant="success" >Success Alert</b-alert>
 <!-- @submit.prevent="search" -->
<form name="form" class="m-3">

 <h6 class="blocked"> Course Name</h6>
  <div class="row">
 
    <div class="col-12 col-md-6 mb-1">
      
     <!-- <input type="text" class="form-control su-border" placeholder="Course" :options="Courses">-->
      <b-form-select v-model="selected"  value-field="Serial" 
         text-field="CourseNameAr" 
         type="text"
         class="form-control">
<option v-for="c in Courses" :key="c.Serial" :value="c.Serial">
         {{c.CourseNameAr}}
       </option>
       
       </b-form-select>
    </div>
 <div class="col-12 col-md-6 mb-1">
  <!--  <button class="btn btn-primary text-center" type="submit">
 
   Search </button> -->
   <b-button  variant="success"  class="btn btn-primary text-center"  @click="BookCourse">Submit</b-button>
   </div>
  </div>
</form>
<div class="m-3">
 




</div>

</div>
 </div>

</template>
<script>

import MilitaryEducationService from '../../services/academic/MilitaryEducationServices'
import studentDataServices from '../../services/student/studentDataServices';
import Help from '../Help.vue';
//import ApplicantService from '../../services/Applicant/Applicant.service';

export default {
  components: { Help },
  name: "MilitaryCourses",
  data() {
    return {
      selected: 9,
        Courses:[],
        Successful:false,
        errormsg:'',
        empty:false,
        personalData:[],
        info:"",
    };
  },

  mounted(){
    studentDataServices.GetStudentData(this.currenUser.StudentID).then(Response =>{
              
              this.personalData = Response.data.StudentData[0]
               // eslint-disable-next-line no-console
                  console.log(Response.data)
          }, error => {
             
                 // eslint-disable-next-line no-console
               //   console.log(error.response.status)
                
             this.message =
               (error.response && error.response.data && error.response.data.Message) ||
               error.message ||
               error.toString();
               
               if(error.response.status == 404) this.message =''
            
           }) 

    MilitaryEducationService.GetAllCourses(this.currenUser.StudentID).then(response=>{
        this.Courses = response.data
this.empty = false;
        // if (this.Courses.length == 0) {
          
        // }
    }, error => {
              
                  // eslint-disable-next-line no-console
                //   console.log(error.response.status)
                  this.empty = true;
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })


  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
          IsMale(){
            return (this.personalData.GenderID === 1 && this.personalData.NationalityNameEN === "Egyptian")
          },
          IsFemale(){
            return (this.personalData.GenderID === 2 && this.personalData.NationalityNameEN === "Egyptian")
          }
        
        },
  methods:{
  
   

    BookCourse()
    {

let   ConfirmObj= {
         
          studentid : this.currenUser.StudentID,
          // CourseId :this.selected
          CourseId :this.Courses[0].Serial
         
        }
        
        console.log(ConfirmObj)
        
MilitaryEducationService.PostStudentReservation(ConfirmObj).then(respone=>{
          console.log(respone.data)
         this.Successful=true
            this.$emit('clicked')


        },error=>{
 this.errormsg =
(error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.errormsg =''

        })


    },
      Back(){
      this.$router.push("/YourCourse");
    }

  },
  
}
</script>


<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
.card-header{
  color: #285475;
  font-size: 21px;

}
.card-title{
    color: #285475;
  font-size: 15px;
  font-weight: bold;

}
.card-text strong{

  color: #285475;
}

.panal{
  background:#fff !important;
  border-radius:10px;
color:rgb(80, 80, 80);
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

.table .thead-light th {
 font-size: 14px;
 width: 15%;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
</style>
